import { useCampaignAddonProducts } from '@campaign-services/hooks/useCampaignAddonProducts'
import { CartSpecialOfferProductList } from '@cart-ui/CartSpecialOfferProductList/CartSpecialOfferProductList'
import { CartSpecialOfferProductListItem } from '@cart-ui/CartSpecialOfferProductListItem/CartSpecialOfferProductListItem'
import { useDialog } from '@dni-hooks/useDialog'
import { type AllProduct } from '@hooks-api/types/dataModel/products'
import { useStmCart } from '../../CartProvider'
import { CartCard } from '../CartCard'
import { CartCardBody } from '../CartCardBody'
import { CartCardHeader } from '../CartCardHeader'
import { DIALOG_SELECT_ADDON_PRODUCT_VARIATION, DialogSelectAddonProductVariation, type DialogSelectAddonProductVariationProps } from './DialogSelectAddonProductVariation'

export const CartAddonProducts = () => {
  const { projectCode, currency, campaignCode } = useStmCart()
  const { allProductMap, addonProducts } = useCampaignAddonProducts({ code: campaignCode, projectCode })
  const { openDialog } = useDialog<DialogSelectAddonProductVariationProps>(DIALOG_SELECT_ADDON_PRODUCT_VARIATION)

  const handleActionClick = (allProduct: AllProduct | undefined) => () => {
    if (!allProduct) return
    openDialog({
      currency,
      parentProductId: allProduct.id,
      productProjectCode: projectCode,
    })
  }

  if (!addonProducts.length) return null

  return (
    <>
      <DialogSelectAddonProductVariation />
      <CartCard>
        <CartCardHeader
          title="加價購"
          subTitle="已達門檻享加價購"
        />
        <CartCardBody>
          <CartSpecialOfferProductList>
            {addonProducts.map(group => (
              <CartSpecialOfferProductListItem
                key={group.allProductId}
                productImgSrc={allProductMap[group.allProductId]?.last_gallery_image || allProductMap[group.allProductId]?.thumbnail}
                productTitle={allProductMap[group.allProductId]?.title}
                currency={currency}
                salePrices={[...new Set(group.variations.map(variation => variation.sale_price))]}
                onActionClick={handleActionClick(allProductMap[group.allProductId])}
              />
            ))}
          </CartSpecialOfferProductList>
        </CartCardBody>
      </CartCard>
    </>
  )
}
